<template>
    <div>

        <!-- loading placeholders -->
        <v-row v-if="loading">
          <v-col v-for="i in (12 / gridCol)"
                 :key="i">
             <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
             ></v-skeleton-loader>
          </v-col>
        </v-row>

        <!-- loaded items -->
        <v-carousel
          :continuous="false"
          :cycle="true"
          :show-arrows="false"
          :hide-delimiters="slides.length <= 1"
          hide-delimiter-background
          delimiter-icon="mdi-minus"
          height="auto"
          v-else
        >
            <v-carousel-item v-for="(slide, i) in slides"
                             :key="i">
                <v-row class="px-5 py-5">
                    <v-col :cols="gridCol"
                           align-self="end"
                           v-for="(item, j) in slide"
                           :key="j">
                        <GridTooltip :item="item">
                            <v-slide-y-transition>
                                <Cover :src="getSrc(item)"
                                       @click="onClick(item)"
                                       :gradient="gradient && !item.canRead"
                                       :shaped="isShaped(item)"/>
                            </v-slide-y-transition>
                        </GridTooltip>
                    </v-col>
                </v-row>
            </v-carousel-item>
        </v-carousel>

    </div>
</template>

<script>
import _ from 'lodash'

import utility from '@/mixins/utility'

import Cover from '@/components/UI/Cover'
import GridTooltip from '@/components/Grids/GridTooltip'

export default 
{
   name: 'SimpleGrid',

   mixins: [ utility ],

   components:
   {
    Cover,
    GridTooltip
   },

   data: () => ({
     
   }),

   props:
   {
      cols:
      {
         type: Number,
         default: 6
      },

      gradient:
      {
         type: Boolean,
         default: false
      },

      items:
      {
         type: Array,
         required: true,
         default: ()=> []
      },

      loading:
      {
         type: Boolean,
         default: false
      },

      mobileCols:
      {
         type: Number,
         default: 2
      },
      
      prop:
      {
        type: String,
        default: 'cover'
      },

      shaped:
      {
         type: Boolean,
         default: false
      },
   },

   computed:
   {
        gridCol()
        {
            let cols = this.isMobile ? this.mobileCols : this.cols

            return (12 / cols)
        },
        
        slides()
        {
            if( this.isMobile )
                return _.chunk(this.items, this.mobileCols)
            
            return _.chunk(this.items, this.cols)
        }
   },

   methods:
   {
        getSrc(item)
        {
            return item[this.prop]
        },

        isShaped(item)
        {
            if( this.shaped )
                return true

            if( !item.pivot || typeof item.pivot != 'object' )
                return false

            if( item.pivot.image === 'custom' ||
                item.pivot.image === 'banner' )
                return true

            return false
        },

        onClick(item)
        {
            this.$emit('click', item)
        }
   },

   load(){}
}
</script>